"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFutureTradeParams = exports.FutureAccountType = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const CustomAssetsProvider_1 = require("../../CustomAssetsProvider");
const FutureIndexProvider_1 = require("../../FutureIndexProvider");
const LeverageConfig_1 = require("../../FutureLeverageProvider/LeverageConfig");
const CalculateUtils_1 = require("./CalculateUtils");
const CheckFutureRequest_1 = require("./CheckFutureRequest");
exports.FutureAccountType = trade_utils_lib_1.AccountTradeType.trader;
const useFutureTradeParams = (props) => {
    var _a;
    const { symbolInfo, marginType, orderSide, orderType, reduceOnly, postOnly, leverage, investSide, price, qty, curPrice: curPriceTemp, isFocused, triggerPrice, } = props;
    // 获取余额信息
    const { quoteBalance: balance, position, riskState, } = (0, CustomAssetsProvider_1.useFPBalanceInfo)(exports.FutureAccountType, symbolInfo.base, symbolInfo.quote, isFocused);
    const isBuySellBase = (orderType === interface_1.CustomOrderType.LIMIT && investSide === interface_1.InvestSymbolSide.quote) === false;
    const markPriceTemp = (_a = (0, FutureIndexProvider_1.useFuturesIndex)(symbolInfo.symbol, isFocused && !triggerPrice)) === null || _a === void 0 ? void 0 : _a.mark_price;
    const curPrice = triggerPrice ? triggerPrice : curPriceTemp;
    const markPrice = triggerPrice ? triggerPrice : markPriceTemp;
    // 获取杠杆倍数信息
    const { curLeverageRow, leverageConfig } = (0, LeverageConfig_1.useLeverageConfigRow)(symbolInfo.symbol, leverage);
    const realQty = (0, react_1.useMemo)(() => {
        var _a;
        let _realQty = new trade_utils_lib_1.SafeDecimal(qty);
        // 用户投quote的时候需要把数值转换成base
        if (!isBuySellBase) {
            _realQty = _realQty.div(new trade_utils_lib_1.SafeDecimal(price)).toDecimalPlaces((_a = symbolInfo.amount) !== null && _a !== void 0 ? _a : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        }
        return _realQty.toString();
    }, [isBuySellBase, price, qty, symbolInfo.amount]);
    const [limitPriceD, curPriceD, tradePriceD] = (0, react_1.useMemo)(() => {
        const _price = new trade_utils_lib_1.SafeDecimal(price);
        const _cur = new trade_utils_lib_1.SafeDecimal(curPrice);
        const _tradeP = orderType === interface_1.CustomOrderType.LIMIT ? _price : _cur;
        return [_price, _cur, _tradeP];
    }, [curPrice, orderType, price]);
    // 反向持仓量
    const [reversePosition, enableReduce] = (0, react_1.useMemo)(() => {
        let rP = new trade_utils_lib_1.SafeDecimal(0);
        const positionQty = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionQuantity);
        if (orderSide === interface_1.CustomOrderSide.BUY) {
            if (positionQty.lessThan(0)) {
                rP = positionQty;
            }
        }
        else {
            if (positionQty.greaterThan(0)) {
                rP = positionQty;
            }
        }
        const _enableReduce = !rP.equals(0);
        return [rP, _enableReduce];
    }, [position === null || position === void 0 ? void 0 : position.positionQuantity, orderSide]);
    const [available, canBuy, canBuyDisplay] = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        const leverD = new trade_utils_lib_1.SafeDecimal(leverage);
        // 反向仓位绝对值
        const reversePositionABS = reversePosition.abs();
        // 可用保证金
        // 2023/1/31  去掉该处的精度处理，由ui层进行截断（原因：如果在此处按照quote的进度进行截断可能会导致精度丢失）
        const avail = (_a = balance === null || balance === void 0 ? void 0 : balance.available) !== null && _a !== void 0 ? _a : "";
        // 计算可买
        let cb = "";
        let cbDisplay = "";
        const availMarinD = new trade_utils_lib_1.SafeDecimal(balance === null || balance === void 0 ? void 0 : balance.availableMargin);
        /** 平仓后的保证金, 有可能为负. 乘以0.95是平了反向仓位后的保证金加的冗余 */
        const tradedMargin = availMarinD.add(reversePositionABS.mul(0.95).mul(tradePriceD).div(leverD));
        /** 平仓后的保证金可投金额： 保证金 * 杠杆倍数，最小值为0 */
        const availInvestD = trade_utils_lib_1.SafeDecimal.max(tradedMargin.mul(leverD), 0);
        // 市价单保证金冗余
        const marketMarginOffset = 0.95;
        const isMarketOrder = orderType === interface_1.CustomOrderType.MARKET_QTY;
        if (isBuySellBase) {
            // 投base
            if (reduceOnly) {
                cb = reversePositionABS.toString();
                cbDisplay = cb;
            }
            else {
                if (tradePriceD.equals(0) === false) {
                    // 保证金可买
                    let marginCB = availInvestD.div(tradePriceD);
                    // 保证金可买 + 反向持仓量
                    cb = marginCB
                        .add(reversePositionABS)
                        .toDecimalPlaces((_b = symbolInfo.amount) !== null && _b !== void 0 ? _b : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                        .toString();
                    if (isMarketOrder) {
                        cbDisplay = marginCB
                            .mul(marketMarginOffset)
                            .add(reversePositionABS)
                            .toDecimalPlaces((_c = symbolInfo.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                            .toString();
                    }
                    else {
                        cbDisplay = cb;
                    }
                }
            }
        }
        else {
            // 投quote
            if (tradePriceD.equals(0) === false) {
                // 反向仓位可投xx quote
                const positionCanCost = reversePositionABS.mul(tradePriceD);
                if (reduceOnly) {
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost, symbolInfo.precision);
                }
                else {
                    // 可投 反向持仓价值 + 乘以杠杆倍数的可投金额
                    cb = positionCanCost
                        .add(availInvestD)
                        .toDecimalPlaces((_d = symbolInfo.precision) !== null && _d !== void 0 ? _d : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                        .toString();
                }
                cbDisplay = cb;
            }
        }
        return [avail, cb, cbDisplay];
    }, [
        balance === null || balance === void 0 ? void 0 : balance.available,
        balance === null || balance === void 0 ? void 0 : balance.availableMargin,
        isBuySellBase,
        leverage,
        orderType,
        reduceOnly,
        reversePosition,
        symbolInfo.amount,
        symbolInfo.precision,
        tradePriceD,
    ]);
    // 开仓所需保证金
    const marginNeed = (0, react_1.useMemo)(() => {
        // 仅减仓时所需保证金为0
        if (reduceOnly) {
            return "0";
        }
        if (!qty || tradePriceD.equals(0)) {
            return "";
        }
        const baseQty = isBuySellBase ? new trade_utils_lib_1.SafeDecimal(qty) : new trade_utils_lib_1.SafeDecimal(qty).div(tradePriceD);
        // 2023/1/31  去掉该处的精度处理，由ui层进行截断（原因：如果在此处按照quote的精度进行截断可能会导致精度丢失）
        // const _marginNeed = NumberCommonUtils.formatterDecimalToStr(
        //     baseQty.mul(tradePriceD).div(new SafeDecimal(leverage)),
        //     symbolInfo.precision,
        //     SafeDecimal.ROUND_CEIL,
        // );
        return baseQty.mul(tradePriceD).div(new trade_utils_lib_1.SafeDecimal(leverage)).toString();
    }, [qty, isBuySellBase, tradePriceD, leverage, reduceOnly]);
    // 预估交易后的仓位价值
    const esNotional = (0, react_1.useMemo)(() => {
        // 已有仓位
        const oldP = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionQuantity);
        // 新增仓位
        const qtyD = new trade_utils_lib_1.SafeDecimal(realQty);
        const newP = orderSide === interface_1.CustomOrderSide.BUY ? qtyD : qtyD.mul(-1);
        // 相加计算价值 向上取整
        const notional = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(oldP.add(newP).mul(tradePriceD), symbolInfo.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        return notional;
    }, [orderSide, position === null || position === void 0 ? void 0 : position.positionQuantity, realQty, symbolInfo.precision, tradePriceD]);
    const [createOrder, verifyCanTrade] = (0, react_1.useMemo)(() => {
        const tradeParams = {
            accountType: exports.FutureAccountType,
            symbol: symbolInfo,
            marginType: marginType,
            leverage: leverage,
            orderType: orderType,
            side: orderSide,
            investSide: investSide,
            available: available,
            canBuy: canBuy,
            price: price,
            curPrice: curPrice,
            markPrice: markPrice,
            amount: qty,
            realAmount: realQty,
            postOnly: postOnly,
            reduceOnly: reduceOnly,
            esNotional: esNotional,
            leverageConfigRow: curLeverageRow,
        };
        return [() => (0, CheckFutureRequest_1.createFutureOrder)(tradeParams), () => (0, CheckFutureRequest_1.verifyFuturesOrder)(tradeParams)];
        // .pipe(
        //     mergeMap((resp) => {
        //         // 如果是市价单, 判断是否被驳回
        //         const isMarket = orderType === CustomOrderType.MARKET_QTY;
        //         // 如果是reduce only, 限价单, 确认下单数量有无变化
        //         const isCheckAmount = reduceOnly && orderType === CustomOrderType.LIMIT;
        //         if (isMarket || isCheckAmount) {
        //             return timer(500).pipe(
        //                 mergeMap(() => {
        //                     return queryCustomOrder({ accountType: FutureAccountType, symbol: symbolInfo.symbol, order_id: resp.id });
        //                 }),
        //                 map((res) => {
        //                     // 市价单, 被取消, 成交量不为0  ===  被IOC了
        //                     if (isMarket && res.status === OrderStatus.CANCELED && Number(res.filled || 0) > 0) {
        //                         // 被IOC挡住, 部分成交. 文案: 您的市价单数量被修改为xxx, 已成交
        //                         res.info = { ...res.info, localCheckState: "-1" };
        //                     }
        //                     const amountD = new SafeDecimal(res.amount);
        //                     const qtyD = new SafeDecimal(res.qty);
        //                     // 初始挂单数量和实际挂单数量不相等
        //                     if (isCheckAmount && amountD.equals(qtyD) === false) {
        //                         // 挂单数量被裁剪. 文案: 下单成功，下单数量被修改为xxxx Quote
        //                         res.info = { ...res.info, localCheckState: "-2" };
        //                     }
        //                     return res;
        //                 }),
        //                 catchError(() => {
        //                     return of(resp);
        //                 }),
        //             );
        //         }
        //         // 其他情况不做订单请求效验
        //         return of(resp);
        //     }),
        // );
    }, [
        symbolInfo,
        marginType,
        leverage,
        orderType,
        orderSide,
        investSide,
        available,
        canBuy,
        price,
        curPrice,
        markPrice,
        qty,
        realQty,
        postOnly,
        reduceOnly,
        esNotional,
        curLeverageRow,
    ]);
    const baseConformParams = (0, react_1.useMemo)(() => {
        return {
            symbolInfo,
            orderType,
            orderSide,
            postOnly,
            investSide,
            price,
            curPrice,
            available,
            qty,
        };
    }, [available, curPrice, investSide, orderSide, orderType, postOnly, price, qty, symbolInfo]);
    const estLiqPrice = (0, react_1.useMemo)(() => {
        if (!isFocused) {
            return "";
        }
        return CalculateUtils_1.CalculateUtils.calculateLiquidatePrice({
            tradeParams: baseConformParams,
            // 产品需求，不需要关心当前的仓位，直接下单的价格进行计算 @neven @gino
            // lastPosition: position,
            leverageConfigs: (leverageConfig === null || leverageConfig === void 0 ? void 0 : leverageConfig.rows) || [],
        });
    }, [baseConformParams, isFocused, leverageConfig === null || leverageConfig === void 0 ? void 0 : leverageConfig.rows]);
    /**下单二次校验的参数 */
    const tradeConformParams = (0, react_1.useMemo)(() => {
        // 生成下单二次确认弹窗需要的参数
        return Object.assign(Object.assign({}, baseConformParams), { symbolInfo: symbolInfo, estLiqPrice, leverage });
    }, [baseConformParams, estLiqPrice, leverage, symbolInfo]);
    return {
        balance: balance,
        riskState: riskState,
        position: position,
        available: available,
        canBuy: canBuy,
        canBuyDisplay: canBuyDisplay,
        marginNeed: marginNeed,
        createOrder: createOrder,
        enableReduceOnly: enableReduce,
        isBuySellBase: isBuySellBase,
        estLiqPrice: estLiqPrice,
        verifyCanTrade,
        tradeConformParams,
    };
};
exports.useFutureTradeParams = useFutureTradeParams;
